module.exports = __webpack_public_path__ + "media/flute.2feb0297.ogg";